module.exports = __webpack_public_path__ + "images/navigation/gold-blush-3d539c71.jpg";